import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import Portal from "../../ui/portal";
import PortalAppBar from "../../ui/portalAppBar";
import PortalGridContent from "../../ui/portalGridContent";
import AdminAssessmentTemplates from "../../widgets/adminAssesmentTemplates";
import AdminReports from "../../widgets/adminReports";
import EmpireEmployees from "../../widgets/empireOS/empireEmployees";

const EmpireAdminPortal = props => {
  return (
    <Portal>
      <PortalAppBar title="Administration" />
      <PortalGridContent>
        <Grid item xs={12} sm={12} md={6}>
          <EmpireEmployees />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <AdminReports />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <AdminAssessmentTemplates />
        </Grid>
        <Grid item xs={12}></Grid>
      </PortalGridContent>
    </Portal>
  );
};

const mapStateToProps = state => ({
  awsGroup: state.userSession.awsGroup,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EmpireAdminPortal));
